module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BranchBox":{"link":"Více informací o prodejně"}}}')
  delete Component.options._Ctor
}
